export default function ({ store, route, req }) {
  const userAgent = process.server ? req.headers['user-agent'] : navigator.userAgent
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  store.state.isMobile = store.state.isMobile ? store.state.isMobile : isMobile
}
